<template>
  <div class="login">
    <el-card class="card">
      <div slot="header">
        <span>司海广告数据平台</span>
      </div>
      <el-form :model="form" :rules="rules" ref="loginForm" label-width="90px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" autocomplete="off" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" autocomplete="off" placeholder="请输入密码" @keyup.enter.native="handleLogin" />
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="captcha-row">
            <el-input v-model="form.code" autocomplete="off" placeholder="请输入验证码" style="width: 60%;" @keyup.enter.native="handleLogin" />
            <img :src="codeUrl" @click="getCode" class="captcha-img" alt="验证码" />
          </div>
        </el-form-item>
      </el-form>
      <el-button type="primary" :loading="loading" @click="handleLogin" style="width: 100%;">
        登 录
      </el-button>
    </el-card>
  </div>
</template>

<script>
import { login, getCodeImg } from '@/api/system/auth';

export default {
  data() {
    return {
      loading: false,
      codeUrl: '',
      form: {
        username: '',
        password: '',
        code: '',
        uuid: ''
      },
      rules: {
        username: [{ required: true, trigger: 'blur', message: '请输入用户名' }],
        password: [{ required: true, trigger: 'blur', message: '请输入密码' }],
        code: [{ required: true, trigger: 'change', message: '请输入验证码' }]
      }
    };
  },
  created() {
    this.getCode();
  },
  methods: {
    async getCode() {
      try {
        const res = await getCodeImg();
        const data = res.data || {};
        if (data.img) {
          this.codeUrl = 'data:image/gif;base64,' + data.img;
          this.form.uuid = data.uuid;
          this.form.code = '';
        }
      } catch (e) {
        console.error('获取验证码失败', e);
        this.$message.error('验证码加载失败');
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          const res = await login(this.form);
          // 后端成功时 code=0，失败时 code!=0 仍为 HTTP 200
          if (res.code !== 0) {
            this.$message.error(res.message || '登录失败');
            this.getCode();
            return;
          }
          const data = res.data || {};
          if (data && data.token) {
            localStorage.setItem('token', data.token);
            this.$router.replace('/dashboard');
          } else {
            this.$message.error(res.message || '登录失败');
            this.getCode();
          }
        } catch (e) {
          const msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : (e.message || '登录失败');
          this.$message.error(msg);
          this.getCode();
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-size: cover;
  overflow: hidden;
}
.card {
  width: 420px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.15) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  border: none !important;
}
.card >>> .el-card__header {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: #303133;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}
.captcha-row {
  display: flex;
  align-items: center;
}
.captcha-img {
  width: 38%;
  height: 38px;
  margin-left: 10px;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
</style>
